export function createFluidState({
  viewDistance = 2,
  waterSeedScanBudgetPerFrame = 72,
  lavaSeedScanBudgetPerFrame = 44,
  waterDirtyBudgetPerTick = 256,
  lavaDirtyBudgetPerTick = 128,
  waterVisualUpdateBudgetPerFluidTick = 220
} = {}) {
  return {
    waterMap: new Map(),
    lavaMap: new Map(),
    lavaSourceSet: new Set(),
    pendingWaterSeedKeys: [],
    pendingLavaSeedKeys: [],
    pendingWaterSeedSet: new Set(),
    pendingLavaSeedSet: new Set(),
    pendingWaterSeedCursor: 0,
    pendingLavaSeedCursor: 0,
    dirtyWaterSet: new Set(),
    dirtyLavaSet: new Set(),
    processingWaterSet: new Set(),
    processingLavaSet: new Set(),
    animatingWaterMeshes: new Set(),
    waterTickAccumulator: 0,
    lavaTickAccumulator: 0,
    runtimeFluidPerformanceTier: 1,
    runtimeWaterSeedBudget: waterSeedScanBudgetPerFrame,
    runtimeLavaSeedBudget: lavaSeedScanBudgetPerFrame,
    runtimeWaterDirtyBudget: waterDirtyBudgetPerTick,
    runtimeLavaDirtyBudget: lavaDirtyBudgetPerTick,
    runtimeWaterVisualBudget: waterVisualUpdateBudgetPerFluidTick,
    runtimeWaterVisualProcessed: 0,
    runtimeWaterVisualDeferred: 0,
    runtimeFluidFocusCx: Number.NaN,
    runtimeFluidFocusCz: Number.NaN,
    runtimeFluidFocusRadius: viewDistance + 1,
    reset() {
      this.waterMap.clear();
      this.lavaMap.clear();
      this.lavaSourceSet.clear();
      this.pendingWaterSeedKeys.length = 0;
      this.pendingLavaSeedKeys.length = 0;
      this.pendingWaterSeedSet.clear();
      this.pendingLavaSeedSet.clear();
      this.pendingWaterSeedCursor = 0;
      this.pendingLavaSeedCursor = 0;
      this.dirtyWaterSet.clear();
      this.dirtyLavaSet.clear();
      this.processingWaterSet.clear();
      this.processingLavaSet.clear();
      this.animatingWaterMeshes.clear();
      this.waterTickAccumulator = 0;
      this.lavaTickAccumulator = 0;
      this.runtimeFluidPerformanceTier = 1;
      this.runtimeWaterSeedBudget = waterSeedScanBudgetPerFrame;
      this.runtimeLavaSeedBudget = lavaSeedScanBudgetPerFrame;
      this.runtimeWaterDirtyBudget = waterDirtyBudgetPerTick;
      this.runtimeLavaDirtyBudget = lavaDirtyBudgetPerTick;
      this.runtimeWaterVisualBudget = waterVisualUpdateBudgetPerFluidTick;
      this.runtimeWaterVisualProcessed = 0;
      this.runtimeWaterVisualDeferred = 0;
      this.runtimeFluidFocusCx = Number.NaN;
      this.runtimeFluidFocusCz = Number.NaN;
      this.runtimeFluidFocusRadius = viewDistance + 1;
    },
    getPendingWaterSeedCount() {
      return Math.max(0, this.pendingWaterSeedKeys.length - this.pendingWaterSeedCursor);
    },
    getPendingLavaSeedCount() {
      return Math.max(0, this.pendingLavaSeedKeys.length - this.pendingLavaSeedCursor);
    }
  };
}
